import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useRouteLoading } from '@/hooks/use-route-loading'

export const RouteProgress: FC = (): ReactNode => {
    const loading = useRouteLoading()

    return (
        <div
            aria-hidden='true'
            className={cn(
                'pointer-events-none fixed inset-x-0 top-0 z-[70] h-0.5 overflow-hidden transition-opacity duration-200',
                loading ? 'opacity-100' : 'opacity-0'
            )}
        >
            <div className='h-full w-1/3 bg-primary motion-safe:animate-[route-progress_1.1s_ease-in-out_infinite]' />
        </div>
    )
}
